import { render } from "./AddContactsModal.vue?vue&type=template&id=1e54a928"
import script from "./AddContactsModal.vue?vue&type=script&lang=js"
export * from "./AddContactsModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__